import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Slide from '@mui/material/Slide';
import { Icon } from '@iconify/react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { FormControl, Grid, MenuItem, Select, TextField } from '@mui/material';
import SubCategoryService from '../../../redux/api/SubCategoryService';
import { getSubCategoryMethod } from '../../../redux/slice/subCategorySlice';
import RichTextEditors from '../../RichText/RichTextEditors';
import GalleyModel from '../../Gallery/GalleyModel';
import Iconify from '../../iconify/Iconify';

const Transition = React.forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);

export default function UpdateSubCategoryDialog({ openEditForm, handleClickOpenEditForm, subCategoryId }) {
  const [folderId, setFolderId] = React.useState(null);
  // Gallery Model
  const [openModel, setOpenModel] = React.useState(false);
  const handleModel = () => {
    setOpenModel(!openModel);
  };
  const dispatch = useDispatch();
  const parentCategoryData = useSelector((state) => state.parentCategory);
  const data = useSelector((state) => state.subCategory);

  const [title, setTitle] = React.useState(null);
  const [description, setDescription] = React.useState(null);
  const [parentCategory, setParentCategory] = React.useState('Please Select Parent Category');
  const [file, setFile] = React.useState([]);

  React.useEffect(() => {
    const result = data?.data && data?.data?.filter((item) => item?._id === subCategoryId);
    if (result && result?.length !== 0) {
      setTitle(result[0]?.name);
      setDescription(result[0]?.category_description);
      setParentCategory(!result[0]?.parent_id?._id ? 'Please Select Parent Category' : result[0]?.parent_id?._id);
      setFolderId(!result[0]?.parent_id?._id ? 'Please Select Parent Category' : result[0]?.parent_id?._id);
      setFile(!result[0]?.category_image ? [] : [result[0]?.category_image]);
    }
  }, [subCategoryId]);

  const handleSubmit = async () => {
    if (!title || !description || parentCategory === 'Please Select Parent Category') {
      toast.error('Please fill all fields');
      return;
    }
    const data = {
      name: title,
      parent_id: parentCategory,
      category_description: description,
      category_image: file[0],
    };
    await SubCategoryService.update(subCategoryId, data)
      .then((res) => {
        if (res.data.success === true) {
          console.warn(res);
          dispatch(getSubCategoryMethod());
          handleClickOpenEditForm();
        }
      })
      .catch((error) => {
        if (!error.response.data.message) {
          toast.error(error.message, { position: 'top-right' });
        } else {
          toast.error(error.response.data.message, { position: 'top-right' });
        }
      });
  };
  return (
    <div>
      <Dialog fullScreen open={openEditForm} onClose={handleClickOpenEditForm} TransitionComponent={Transition}>
        <AppBar sx={{ position: 'relative', backgroundColor: '#70AD47' }}>
          <Toolbar>
            <IconButton edge="start" color="inherit" onClick={handleClickOpenEditForm} aria-label="close">
              {/* <CloseIcon /> */}
              <Icon icon="ic:outline-close" />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              Edit Sub Category
            </Typography>
            {/* <Button autoFocus variant="outlined" sx={{ color: 'white', borderColor: 'white' }} onClick={handleSubmit}>
              Edit
            </Button> */}
          </Toolbar>
        </AppBar>
        <Grid container spacing={2} sx={{ textAlign: 'left', padding: '3%' }}>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{ textAlign: 'center' }}>
            <Typography variant="h5">Edit Sub Category</Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Typography variant="caption" sx={{ fontWeight: 'bold' }}>
              Sub Category Title
            </Typography>
            <TextField
              id="outlined-basic"
              placeholder="Sub Category Title"
              variant="outlined"
              fullWidth
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              required
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Typography variant="caption" sx={{ fontWeight: 'bold' }}>
              Parent Category
            </Typography>
            <FormControl fullWidth>
              <Select
                value={parentCategory}
                onChange={(e) => {
                  setParentCategory(e.target.value);
                  setFolderId(e.target.value);
                }}
                sx={{ textAlign: 'left' }}
              >
                <MenuItem value="Please Select Parent Category" disabled selected>
                  Please Select Parent Category
                </MenuItem>
                {parentCategoryData.data !== null &&
                  parentCategoryData.data !== undefined &&
                  parentCategoryData.data.map((item) => (
                    <MenuItem key={item._id} value={item._id}>
                      {item.name}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Typography variant="caption" sx={{ fontWeight: 'bold' }}>
              Sub Category Description
            </Typography>
            <RichTextEditors placeholder="Sub Category Description" body={description} setBody={setDescription} />
            {/* <TextField
              id="outlined-basic"
              placeholder="Parent Category Description"
              multiline
              rows={5}
              variant="outlined"
              fullWidth
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              required
            /> */}
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{ textAlign: 'left' }}>
            <Typography variant="caption" sx={{ fontWeight: 'bold' }}>
              Upload Image
            </Typography>
            <br />
            {/* <input
              accept="image/*"
              type="file"
              id="select-image"
              onChange={(e) => setFile(e.target.files[0])}
              required
            /> */}
            <Button
              variant="contained"
              size="small"
              startIcon={<Iconify icon="solar:gallery-bold" />}
              onClick={() => {
                if (!folderId) {
                  toast.error('Please select main category');
                  window.scrollTo(0, 0);
                  return;
                }
                handleModel();
              }}
            >
              Choose Image
            </Button>
          </Grid>
          <GalleyModel
            openModel={openModel}
            handleModel={handleModel}
            folderId={folderId}
            setFile={setFile}
            file={file}
          />
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{ textAlign: 'left' }}>
            <Button
              autoFocus
              variant="contained"
              sx={{ color: 'white', borderColor: 'white', width: '10%' }}
              onClick={() => {
                handleSubmit();
                // handleClickOpenEditForm();
              }}
            >
              Save Changes
            </Button>
          </Grid>
        </Grid>
      </Dialog>
    </div>
  );
}
